"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var ticket_service_1 = require("../../../tickets/ticket.service");
var JobReferenceCell = /** @class */ (function () {
    function JobReferenceCell(ticketService) {
        this.ticketService = ticketService;
        this.value = '';
    }
    JobReferenceCell.prototype.agInit = function (params) {
        this.params = params;
        this.gridApi = params.api;
    };
    JobReferenceCell.prototype.ngAfterViewInit = function () { };
    JobReferenceCell.prototype.getValue = function () {
        if (this.reference) {
            return this.reference.jobName;
        }
        var cell = this.gridApi.getFocusedCell();
        var row = this.gridApi.getDisplayedRowAtIndex(cell.rowIndex);
        return row && row.data.jobName ? row.data.jobName : '';
    };
    JobReferenceCell.prototype.isCancelBeforeStart = function () {
        return false;
    };
    JobReferenceCell.prototype.isCancelAfterEnd = function () {
        return false;
    };
    JobReferenceCell.prototype.isPopup = function () {
        return true;
    };
    JobReferenceCell.prototype.onReferenceClicked = function (reference) {
        var _this = this;
        var cell = this.gridApi.getFocusedCell();
        var row = this.gridApi.getDisplayedRowAtIndex(cell.rowIndex);
        this.ticketService.updateFieldReference(row.data.id, reference, 'job').subscribe(function (ticket) {
            _this.reference = reference;
            row.setData(ticket);
            _this.gridApi.stopEditing();
        });
    };
    JobReferenceCell.prototype.onReferenceClosed = function () {
        this.gridApi.stopEditing();
    };
    return JobReferenceCell;
}());
exports.JobReferenceCell = JobReferenceCell;
